import { render, staticRenderFns } from "./firstGoodsTask.vue?vue&type=template&id=64ffb04f&scoped=true"
import script from "./firstGoodsTask.vue?vue&type=script&lang=js"
export * from "./firstGoodsTask.vue?vue&type=script&lang=js"
import style0 from "./firstGoodsTask.vue?vue&type=style&index=0&id=64ffb04f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ffb04f",
  null
  
)

export default component.exports